/*
 * @Description: 
 * @Version: 2.0
 * @Autor: Seven
 * @Date: 2021-12-20 10:40:40
 * @LastEditors: Seven
 * @LastEditTime: 2022-01-24 10:46:25
 */

const downloadExcel = (stream, fileName) => {
	let a = document.createElement("a");
	let filename = fileName ? `${fileName}.xlsx` : `${+new Date()}.xlsx`
	try {
		var blob = new Blob([stream], {
			type: 'application/vnd.ms-excel,charset=utf-8'
			// type: 'application/ms-excel,charset=utf-8'
		});
	} catch (e) {
		window.BlobBuilder = window.BlobBuilder ||
			window.WebKitBlobBuilder ||
			window.MozBlobBuilder ||
			window.MSBlobBuilder;
		// if (e.name == 'TypeError' && window.BlobBuilder) {
		// 	var blobbuilder = new BlobBuilder();
		// 	BlobBuilder.append(data);
		// 	var blob = blobbuilder.getBlob('application/vnd.ms-excel,charset=utf-8');
		// } else {
		// 	alert("浏览器版本较低，暂不支持该文件类型下载");
		// }
	}
	let url = window.URL.createObjectURL(blob);

	a.setAttribute("href", url)
	a.download = filename
	document.body.appendChild(a);
	a.click()
	document.body.removeChild(a);
}


export {
	downloadExcel
}
// exportExcelPost (data, fileName){
//     const link = document.createElement("a");
//     const blob = new Blob([data], { type: "application/x-excel" });
//     link.style.display = "none";
//     link.href = URL.createObjectURL(blob);
//     link.download = fileName || `导出.xlsx`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
// }
/* 下载的方法，以流的形式 */